
export default function ProgrammesSidebar() {
  const quickLinks = [
    {
      title: 'Download Programme Catalogue',
      description: 'Complete overview of all our training programmes',
      icon: 'ri-download-cloud-line',
      action: 'download'
    },
    {
      title: 'Download SETA Compliance Guide',
      description: 'Understanding SETA requirements and compliance',
      icon: 'ri-file-text-line',
      action: 'download'
    },
    {
      title: 'Request Custom Training',
      description: 'Tailored training solutions for your organisation',
      icon: 'ri-settings-3-line',
      action: 'request'
    },
    {
      title: 'Schedule Consultation',
      description: 'Speak with our training specialists',
      icon: 'ri-calendar-line',
      action: 'schedule'
    }
  ];

  const handleAction = (action: string, title: string) => {
    if (action === 'download') {
      // Simulate download
      console.log(`Downloading: ${title}`);
    } else if (action === 'request') {
      // Navigate to contact or request form
      console.log(`Requesting: ${title}`);
    } else if (action === 'schedule') {
      // Navigate to scheduling
      console.log(`Scheduling: ${title}`);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-[#1A1A1A] mb-4">
          Quick Links
        </h3>
        <div className="space-y-4">
          {quickLinks.map((link, index) => (
            <div 
              key={index}
              className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => handleAction(link.action, link.title)}
            >
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#2D7F3E] text-white rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                  <i className={`${link.icon} text-lg`}></i>
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-[#1A1A1A] text-sm mb-1">
                    {link.title}
                  </h4>
                  <p className="text-xs text-gray-600">
                    {link.description}
                  </p>
                </div>
                <i className="ri-arrow-right-s-line text-gray-400 ml-2"></i>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Information */}
      <div className="green-panel bg-[#2D7F3E] text-white rounded-lg p-6">
        <h3 className="text-lg font-normal mb-4">
          Need Help Choosing?
        </h3>
        <p className="text-sm text-white/90 mb-4">
          Our training specialists are here to help you find the right programme for your needs.
        </p>
        <div className="space-y-3 text-sm">
          <div className="flex items-center">
            <i className="ri-phone-line mr-2"></i>
            <span>+27 10 224 0406</span>
          </div>
          <div className="flex items-center">
            <i className="ri-mail-line mr-2"></i>
            <span>info@sylman.co.za</span>
          </div>
          <div className="flex items-center">
            <i className="ri-time-line mr-2"></i>
            <span>Mon-Fri: 08:30-16:30</span>
          </div>
        </div>
        <button className="w-full bg-white text-[#2D7F3E] px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors font-medium text-sm mt-4 whitespace-nowrap">
          Contact Us Now
        </button>
      </div>

    </div>
  );
}
